export const FILTROS_ESTADISTICAS_INICIALES = {
  desde: '',
  hasta: '',
};

export const METODO_PAGO_LABELS = {
  transferencia: 'Transferencia',
  efectivo: 'Efectivo',
  tarjeta: 'Tarjeta',
  mercado_pago: 'Mercado Pago',
};

export const ESTADO_SERVICIO_LABELS = {
  activo: 'Activo',
  aviso_deuda: 'Aviso de deuda',
  aviso_corte: 'Aviso de corte',
  cortado: 'Cortado',
};

export const ESTADO_BOLETA_LABELS = {
  pendiente: 'Pendiente',
  procesando: 'Procesando',
  pagada: 'Pagada',
  vencida: 'Vencida',
  plan_pago: 'Plan de pago',
  anulada: 'Anulada',
};

export function crearParamsFecha(filtros) {
  return {
    desde: filtros.desde || undefined,
    hasta: filtros.hasta || undefined,
  };
}

export function formatearFechaInput(value) {
  if (!value) {
    return '';
  }

  const [anio, mes, dia] = value.split('-');
  if (!anio || !mes || !dia) {
    return value;
  }

  return `${dia}/${mes}/${anio}`;
}

export function describirPeriodo(filtros) {
  if (filtros.desde && filtros.hasta) {
    return `${formatearFechaInput(filtros.desde)} al ${formatearFechaInput(filtros.hasta)}`;
  }

  if (filtros.desde) {
    return `Desde ${formatearFechaInput(filtros.desde)}`;
  }

  if (filtros.hasta) {
    return `Hasta ${formatearFechaInput(filtros.hasta)}`;
  }

  return 'Sin filtro de fechas';
}

export function describirTendencia(filtros) {
  return filtros.desde
    ? 'Periodo filtrado'
    : 'Últimos 12 meses';
}

export function crearFechaReporte() {
  return new Intl.DateTimeFormat('es-AR', {
    dateStyle: 'short',
    timeStyle: 'short',
  }).format(new Date());
}

export function etiquetaMetodoPago(metodo) {
  return METODO_PAGO_LABELS[metodo] || metodo.replaceAll('_', ' ');
}

export function etiquetaEstadoServicio(estado) {
  return ESTADO_SERVICIO_LABELS[estado] || estado.replaceAll('_', ' ');
}

export function etiquetaEstadoBoleta(estado) {
  return ESTADO_BOLETA_LABELS[estado] || estado.replaceAll('_', ' ');
}
